module.exports = __webpack_public_path__ + "img/1596473783.4e67c937.jpg";